// extracted by mini-css-extract-plugin
export default {"exercise_btn":"Button_exercise_btn__I6R6W"};